<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar"
    >
        <v-list>
            <v-list-item
                v-for="(item, index) in data.items"
                :key="`item-${index}`"
                class="models-nav-item pb-8"
            >
                <a
                    href="#"
                    class="main-nav-item main-nav-item_start"
                    :class="{ active: item.active}"
                    @click.prevent="setActive(item)"
                >
                    <span class="nav-text global-nav">
                        {{ item.text }}
                    </span>
                </a>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'ConfTourModelsSidebar',
        props: [
            'data',
            'handler'
        ],
        mounted() {
            this.handler();
        },
        methods: {
            setActive(currentItem) {
                if (!currentItem.active)
                    this.data.items.forEach(item => {
                        item.active = currentItem.link === item.link;
                    });

                EventBus.$emit('updateLoadedWidgets', {
                    id: "conf-models",
                    link: currentItem.link,
                    active: true,
                    widgetType: "conf-models"
                });
            },

        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/ConfTourModelsSidebar.vue